"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._LifecycleExpiration = {
    type: "structure",
    required: [],
    members: {
        Date: {
            shape: {
                type: "timestamp",
                timestampFormat: "iso8601"
            }
        },
        Days: {
            shape: {
                type: "integer"
            }
        },
        ExpiredObjectDeleteMarker: {
            shape: {
                type: "boolean"
            }
        }
    }
};
//# sourceMappingURL=_LifecycleExpiration.js.map